module.exports = __webpack_public_path__ + "static/media/globalinvestmentforum.fccdbbf9.zip";